module.exports = __webpack_public_path__ + "static/SectionThreeBackground.03206d0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pngs/SectionThreeBackground.png
// module id = 136
// module chunks = 35783957827783 72138227098318